var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstCandyland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0619 21.9821L50.8192 10.9525C51.3433 8.85587 53.8661 7.78946 55.5858 9.09823C55.7047 9.1887 55.8189 9.2884 55.9276 9.39702C56.5791 10.0486 56.905 10.9025 56.9051 11.7567C56.905 12.4792 57.6094 12.9984 58.3215 12.8768C59.6959 12.6422 61.1592 13.0554 62.2201 14.1163C63.281 15.1772 63.6942 16.6405 63.4597 18.015C63.3381 18.7271 63.8573 19.4315 64.5798 19.4314C65.4339 19.4314 66.2879 19.7574 66.9395 20.4089C67.0481 20.5176 67.1478 20.6318 67.2382 20.7506C68.547 22.4704 67.4805 24.9931 65.384 25.5173L54.3544 28.2746",
    fill: "#F2AE1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0619 21.9821L50.8192 10.9525C51.3433 8.85587 53.8661 7.78946 55.5858 9.09823C55.7047 9.1887 55.8189 9.2884 55.9276 9.39702C56.5791 10.0486 56.905 10.9025 56.9051 11.7567C56.905 12.4792 57.6094 12.9984 58.3215 12.8768C59.6959 12.6422 61.1592 13.0554 62.2201 14.1163C63.281 15.1772 63.6942 16.6405 63.4597 18.015C63.3381 18.7271 63.8573 19.4315 64.5798 19.4314C65.4339 19.4314 66.2879 19.7574 66.9395 20.4089C67.0481 20.5176 67.1478 20.6318 67.2382 20.7506C68.547 22.4704 67.4805 24.9931 65.384 25.5173L54.3544 28.2746",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6109 55.0174L24.8536 66.047C24.3295 68.1436 21.8067 69.21 20.087 67.9013C19.9681 67.8108 19.8539 67.7111 19.7452 67.6025C19.0937 66.9509 18.7678 66.097 18.7677 65.2428C18.7678 64.5203 18.0634 64.0012 17.3513 64.1227C15.9769 64.3573 14.5136 63.9441 13.4527 62.8832C12.3918 61.8223 11.9786 60.359 12.2131 58.9845C12.3346 58.2724 11.8155 57.568 11.093 57.5681C10.2389 57.5681 9.38486 57.2421 8.73332 56.5906C8.62469 56.4819 8.525 56.3677 8.43463 56.2489C7.12576 54.5291 8.19226 52.0064 10.2888 51.4823L21.3184 48.7249",
    fill: "#F2AE1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6109 55.0174L24.8536 66.047C24.3295 68.1436 21.8067 69.21 20.087 67.9013C19.9681 67.8108 19.8539 67.7111 19.7452 67.6025C19.0937 66.9509 18.7678 66.097 18.7677 65.2428C18.7678 64.5203 18.0634 64.0012 17.3513 64.1227C15.9769 64.3573 14.5136 63.9441 13.4527 62.8832C12.3918 61.8223 11.9786 60.359 12.2131 58.9845C12.3346 58.2724 11.8155 57.568 11.093 57.5681C10.2389 57.5681 9.38486 57.2421 8.73332 56.5906C8.62469 56.4819 8.525 56.3677 8.43463 56.2489C7.12576 54.5291 8.19226 52.0064 10.2888 51.4822L21.3184 48.7249",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2082 25.1285C58.5932 32.5134 58.5932 44.4869 51.2082 51.8719C43.8232 59.2569 31.8497 59.2569 24.4647 51.872C17.0798 44.487 17.0798 32.5135 24.4648 25.1285C31.8498 17.7435 43.8232 17.7435 51.2082 25.1285Z",
    fill: "#F2AE1D",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2848 50.6918L15.8124 55.8045",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5317 60.5234L25.6444 53.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3879 26.308L59.8603 21.1952",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.141 16.4758L50.0283 23.9482",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8267 46.0703C22.8739 44.0231 21.3008 42.4499 23.3482 40.4026C23.7362 40.0146 24.1071 39.7565 24.4674 39.5793",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6483 37.7964C53.6956 35.7491 52.1225 34.176 54.1698 32.1287C54.5578 31.7407 54.9287 31.4826 55.289 31.3054",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8413 46.0156H38.0333V33.6556L35.4173 36.3676L33.7853 34.6636L38.3933 30.0076H40.8413V46.0156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstCandyland);
export default __webpack_public_path__ + "static/media/firstCandyland.c3d186bcd324dfda88d9926dd9b25513.svg";
export { ForwardRef as ReactComponent };